import {AbstractError} from '../../../abstract-error';

/**
 *
 */
class AnalyticsQueueException extends AbstractError {}

export default AnalyticsQueueException;



// WEBPACK FOOTER //
// ./analytics-queue/src/AnalyticsQueueException/index.js